import useRefreshToken from '@api/hooks/useRefreshToken';

function RefreshToken() {
	useRefreshToken();

	return null;
}

export default RefreshToken;
